import apiClient from './ApiService';

const getUserData = async () => apiClient.get('user');

const AuthService = {
  // getCurrentUser,
  getUserData,
};
export default AuthService;
